export const NLPConfigConstants = {
    UI_SET_NLP_ACTIVE_VIEW: 'UI_SET_NLP_ACTIVE_VIEW',
    UI_SET_SELECTED_APP: 'UI_SET_SELECTED_APP',
    UI_SET_NLP_SCHEMA_ID: 'UI_SET_NLP_SCHEMA_ID',
    UI_SET_NLP_APP_DATA: 'UI_SET_NLP_APP_DATA',
    UI_SET_NLP_SELECTED_INTENT: 'UI_SET_NLP_SELECTED_INTENT',
    UI_UPDATE_INTENT_NAME: 'UI_UPDATE_INTENT_NAME',
    UI_SET_ENTITY_DATA: 'UI_SET_ENTITY_DATA'
};